export * from "./src/build-email-link.pipe";
export * from "./src/mail.module";
